import {get,post} from '../utils/request';

// 赛事列表
export const getMatchList = params => get('/match/info/list',params);
// 修改赛事
export const updateMatch = params => post('/match/info/update',params);
// 创建赛事
export const addMatch = params => post('/match/info/add',params);
// 删除列表
export const deleteMatch = params => post('/match/info/delete',params);
// 添加通知
export const addNotice = params => post('/notice/add',params);
// 修改通知
export const updateNotice = params =>post('/notice/update',params);
// 通知详情
export const noticeDetail = params => get('/notice/detail',params);
// 通知列表
export const noticeList = params =>get('/notice/list',params);
// 删除通知
export const deleteNotice = params => post('/notice/delete',params);